import type { RankedPlaybackSource } from "./sourceRanking";

export type SourceRecoveryDecision = {
  candidate?: RankedPlaybackSource;
  exhausted: boolean;
};

/** Select the next automatic fallback from the same ranked model shown in UI. */
export function chooseRecoverySource(
  rankedSources: RankedPlaybackSource[],
  attemptedSourceIds: ReadonlySet<string>,
  currentSourceId?: string,
): SourceRecoveryDecision {
  const candidate = rankedSources.find(({ source, ignored }) => {
    const id = source.Id;
    return Boolean(id && id !== currentSourceId && !ignored && !attemptedSourceIds.has(id));
  });
  return { candidate, exhausted: !candidate };
}
